import PremiumRemindModal from './PremiumRemindModal'
export default PremiumRemindModal
